export class EmployeeId {
    id: number

    constructor(id: number) {
        this.id = id;
    }

}

export class departmentIdReq{
    departmentId:number
    constructor(
    departmentId:number
    ){
        this.departmentId=departmentId
    }
}